import { render, staticRenderFns } from "./trade-add-edit.page.vue?vue&type=template&id=18e3dc7a&"
import script from "./trade-add-edit.page.vue?vue&type=script&lang=js&"
export * from "./trade-add-edit.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\mzkj\\要炼\\yl-pc-business\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18e3dc7a')) {
      api.createRecord('18e3dc7a', component.options)
    } else {
      api.reload('18e3dc7a', component.options)
    }
    module.hot.accept("./trade-add-edit.page.vue?vue&type=template&id=18e3dc7a&", function () {
      api.rerender('18e3dc7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/trade/tabTrade/trade-add-edit.page.vue"
export default component.exports